import { DateRange, DateRangeType } from '@treasury/presentation/components/tm-date-range';
import { sub } from 'date-fns';

export const defaultTransactionDateRange: DateRange = {
    rangeType: DateRangeType.DateRange,
    startDate: sub(new Date(), { weeks: 1, days: 1 }),
    endDate: sub(new Date(), { days: 1 }),
};
